// CFOP de bonificacao/remessa nao vira CFOP do CADASTRO do produto ([DA-680]).
//
// Mora no shared porque tem dois consumidores: a importacao no servidor (o `UPDATE produtos` de
// produto que JA existe, via `cfopParaCadastro` em lancamentos/utils) e a tela de importar nota,
// que CRIA o produto novo pelo `POST /api/produtos` com o CFOP do XML. Uma regra so — duas
// definicoes de "e' bonificacao" teriam que andar em sincronia ([DA-463]).

/**
 * Familia 5910-5914 / 6910-6914: bonificacao, doacao, brinde, amostra gratis, demonstracao,
 * exposicao e feira. Nenhuma delas descreve uma VENDA, entao nenhuma serve de CFOP padrao do
 * cadastro. ⚠️ De proposito NAO inclui `5101`/`6101` (venda de producao propria) nem `6102` — essas
 * SAO vendas e fazem parte da pergunta pendente ao contador, que e' dele, nao minha.
 */
export function ehCfopBonificacao(cfop: string | null | undefined): boolean {
  return /^[56]9(10|11|12|13|14)$/.test((cfop ?? '').trim());
}

/**
 * CFOP do produto NOVO criado na importacao. Bonificacao nasce `5102` — regra dele, 30/10/2026
 * (*"pode atualizar para as proximas ja sair com cfop 5102 no cadastro do produto"*), depois que o
 * brinde da MARTINS 5792300 criou o produto 1708 com `5910`. O resto passa como veio do XML.
 * Produto que ja existe nao passa por aqui: la a trava MANTEM o CFOP atual (`cfopParaCadastro`).
 */
export function cfopProdutoNovo(cfopDoXml: string | null | undefined): string | null {
  const c = (cfopDoXml ?? '').trim();
  if (!c) return null;
  return ehCfopBonificacao(c) ? '5102' : c;
}
